import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { NicaAnagraficaComponent, ToolbarButton } from '../../nica-anagrafica/nica-anagrafica.component';
import { Apiservice } from '../../../services/api.service';
import { ModelliStampaService } from '../../../services/modelli-stampa.service';
import { AutoTablePDFConfig } from '../../shared/anteprima-pdf/AutoTablePDFConfig';
import { ComponentService } from '../../../services/component.service';
import { alert } from 'devextreme/ui/dialog';
import { NewNicaFormComponent } from '../../nica-form/new-nica-form.component';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-crm-procedure',
  templateUrl: './crm-procedure.component.html',
  styleUrls: ['./crm-procedure.component.css'],
})
export class CrmProcedureComponent implements OnInit {
  @ViewChild('crmProcedureForm', { static: false }) crmProcedureForm!: NewNicaFormComponent;
  @ViewChild('crmProcedure', { static: false }) crmProcedure!: NicaAnagraficaComponent;
  @Input() titolo: string;
  dataSource: any = [];
  pulsantiOpzionali: ToolbarButton[];
  selectedRows: number[] = [];
  checkModificaPrezzi: boolean = true;
  partnerData: { [key: string]: any } = {
    isPartner: false,
    isSegreteria: false,

  }
  constructor(
    private stampaPdfService: ModelliStampaService,
    private apiService: Apiservice,
    private userService: ComponentService,
    public cdref: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.getDataSource();
    this.pulsantiOpzionali = [
      {
        location: 'after',
        widget: 'dxButton',
        cssClass: 'export-pdf-button',
        options: {
          icon: 'export icon-file-pdf',
          title: 'Esporta PDF',
          text: 'Esporta PDF',
          id: 'export-pdf-button',
          class: 'iconeToolbar',
          stylingMode: 'text',
          disabled: false,
          visible: true
        }
      }, {
        location: 'after',
        widget: 'dxButton',
        cssClass: 'export-pdf-button',
        name: 'modificaPrezzi',
        options: {
          icon: 'edit',
          title: 'Modifica Percentuali',
          text: 'Modifica Percentuali',
          id: 'modifica-percentuali',
          class: 'iconeToolbar',
          stylingMode: 'text',
          disabled: true,
          visible: this.partnerData.isPartner === false
        }
      }
    ];
  }

  async getDataSource() {
    try {
      const response = await this.apiService.GetApiRest('procedure');
      this.dataSource = response["items"];
      console.log('Dati ricevuti procedure:', this.dataSource);

    } catch (error) {
      console.error('Errore nel caricamento dei dati delle procedure:', error);
    }
  }

  async optionalBottoneToolbar(event: any) {
    console.log(event);
    if (event === 0) {
      if (this.dataSource && this.dataSource.length > 0) {

        const headers = [
          {
            caption: 'Sigla',
            field: 'Sigla'
          },
          {
            caption: 'Descrizione',
            field: 'Des'
          },
          {
            caption: 'Versione',
            field: 'Ver'
          },
          {
            caption: 'Licenza',
            field: 'Licenza'
          },
          {
            caption: 'Assistenza',
            field: 'Assistenza'
          },
          {
            caption: 'Note',
            field: 'Note'
          }

        ];

        let config = new AutoTablePDFConfig();

        config.Rows = this.dataSource;
        config.Page.orientamento = 'l';
        config.Page.formato = 'a4'
        config.Headers = headers

        await this.stampaPdfService.generaPDFAutoTable(config, "ELENCO PROCEDURE", "download");

      } else {
        console.warn('Nessun dato disponibile per il PDF');
        // this.stampaPdfService.generaPdf();
      }
    } else if (event === 1) {
      console.log('Modifica Prezzi', this.selectedRows)
      this.apriPopupModificaPrezzi()
    }
  }

  apriPopupModificaPrezzi() {
    console.log('stampo le row selezionate', this.selectedRows)

    const instanceData = {
      api: `aggiornalistino`,
      api_rest: true,
      filterEditor: `/`,
      remoteOperation: false,
      filterList: "",
      formActionType: "edit",
      formType: "simple",
      idTabRif: [],
      isEdit: false,
      masterKey: 'id',
      nCol: 2,
      queryFilter: [],
      service: "crmProcedureModificaPrezzi",
      widthForm: 600,
      selectedRows: this.selectedRows,
      standardBtnBottom: [22, 23],
    };



    const titoloPopup = 'Procedure';
    const guid = Math.random().toString().replace('0.', '');



    console.log('stampo crmProcedureModificaPrezzi', instanceData)

    this.userService.setNewPopUp(
      guid,
      'NewNicaFormComponent',
      false,
      '600',
      null,
      instanceData,
      false,
      true,
      titoloPopup,
      'top'
    );

    this.userService.outputComponent.subscribe((currentOutput) => {
      if (currentOutput.name === 'beforSave' && 'percLic' in currentOutput.formData && 'percAss' in currentOutput.formData && currentOutput.guid === guid) {
        currentOutput.cancella = true;
        if (currentOutput.formData.percLic == null && currentOutput.formData.percAss == null) {
          alert('Devi compilare almeno uno tra "Percentuale Licenza" e "Percentuale Assistenza".', 'Attenzione!');
          return;
        }

        const percLic = currentOutput.formData.percLic != null ? currentOutput.formData.percLic : 0;
        const percAss = currentOutput.formData.percAss != null ? currentOutput.formData.percAss : 0;
        const applicaClienti = currentOutput.formData.applicaClienti != null ? currentOutput.formData.applicaClienti : 0;
        const queryString = `aggiornalistino?percAss=${percAss}&percLic=${percLic}&applicaClienti=${applicaClienti}&id=${this.selectedRows.join(',')}`;
        this.apiService.GetApiRest(queryString)
          .then((response) => {
            console.log('Risposta API:', response);
            this.userService.destroyCurrentOpenPopUpByGuid(currentOutput.guid);
            this.userService.destroyOutputComponent();

            notify({
              message: 'Percentuali modificate',
              height: 45,
              width: 250,
              position: 'center center'

            }, 'success', 3000);

            if (this.crmProcedure) {
              this.crmProcedure.refresh()
            }

          })
          .catch((error) => {
            console.error('Errore durante la chiamata API:', error);
            alert('Errore durante l\'aggiornamento del listino.', 'Errore!');
          });
      }

      if (currentOutput.name === 'return') {
        this.userService.destroyCurrentOpenPopUpByGuid(currentOutput.guid);
        this.userService.destroyOutputComponent();
      }
    });
  }



  onRowSelectionChanged(event) {
    this.selectedRows = event.selectedRowKeys
    // this.pulsantiOpzionali[1].options.disabled = (this.selectedRows.length > 0) ? false : true
    // if(this.selectedRows.length > 0){
    //   this.crmProcedure.disableCustomButton('modifica-percentuali', true)
    // }
  }

  onAllEvent(event) {
    if (event && event.name && (event.name === 'searchPanel' || event.name === 'onContentReady')) {
      event.component.clearSelection()
    }
    if (event && event.name && event.name === "formContentInitializzed") {

      const data = event.formData
      const component = event.component
      if (data && component) {
        const isModuloValue = component.dataSet['isModulo']
        if (isModuloValue) {
          // console.log(component.itemOption())
          component.itemOption('ModificaProcedura.accettaModuli', 'disabled', isModuloValue === 1);
        }
        // console.log(isModulo)
        // console.log(accettaModuli)
      }
    }
    if (event && event.name && event.name === "onValueChanged") {
      // console.log(event)
      const component = event.masterComponent
      if (component && event.campo && event.campo.dataField === "isModulo") {
        const isModuloValue = event.value
        if (isModuloValue === 1) {
          component.itemOption('ModificaProcedura.accettaModuli', 'disabled', true);
          component.dataSet['accettaModuli'] = 0
          component.elementRef['accettaModuli'].onInitialized.component.option('value', false)
        } else {
          component.itemOption('ModificaProcedura.accettaModuli', 'disabled', false);
        }
      }
    }


  }
}


